import React from 'react';
export function Footer() {
  return <footer className="w-full bg-white py-16 px-4 border-t border-border-light" data-id="element-76">
      <div className="max-w-4xl mx-auto text-center" data-id="element-77">
        <div className="text-text-main text-2xl font-black tracking-widest mb-4" data-id="element-78">
          EDULABS™ Italia
        </div>
        <p className="text-text-sec text-lg font-medium mb-10" data-id="element-79">
          Risorse professionali per la Scuola Secondaria.
        </p>
        <p className="text-text-sec/60 text-sm tracking-wider" data-id="element-80">
          © 2026 All Rights Reserved.
        </p>
      </div>
    </footer>;
}